$(document).ready(function () {
    $('.js_accordionWrap .accordionTitle').on('click', function(e) {
        e.preventDefault();
        var $this = $(this);

        $this.parent().toggleClass('active');
        $this.next('.accordionContent').stop(true, true).slideFadeToggle();
    });
});